<template>
  <div class="golden-link">
    <section class="home-banner container">
      <div class="row d-flex flex-column-reverse flex-md-row">
        <div class="col-12 col-md-5">
          <img src="../assets/home-banner.png" alt="home banner" />
        </div>
        <div class="col-12 col-md-7 text-md-end">
          <span class="home-banner-text" v-html="$t('home-old.title')"></span>
        </div>
      </div>
    </section>
    <!-- app intro -->
    <section class="container">
      <header class="w-100 text-center mb-5 mt-3">
        <h4>
          {{ $t("home-old.subtitle") }}
        </h4>
      </header>

      <div class="w-100 text-center my-3" @click="clickToCopy()">
        <h3 class="text-golden fw-bold">{{ $t("download.referral-text") }}</h3>
        <img
          src="../assets/copy.png"
          alt="Copy referrer code"
          class="d-block mx-auto my-3"
        />
      </div>
      <div class="row">
        <div
          class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-end"
        >
          <a href="https://goldenlinkplus.net/000/g1.2.apk" class="text-center">
            <img
              src="../assets/gplay.png"
              alt="Google Play Link"
              class="w-75"
            />
          </a>
        </div>
        <div
          class="col-12 col-sm-6 d-flex justify-content-center justify-content-sm-start"
        >
          <a href="https://testflight.apple.com/join/LPHHa2CK" class="text-center">
            <img
              src="../assets/astore.png"
              alt="Apple Store Link"
              class="w-75"
            />
          </a>
        </div>
      </div>
      <div class="w-100 my-3 text-center">
        <div class="btn btn-gold px-3">
          <a
            class="text-white"
            href="https://www.goldenlinkplus.net/web_reg/#/socialmedia/socialmedia_reg_intro?referral_code=GoldMining_G"
            >{{ $t("home-old.register") }}</a
          >
        </div>
      </div>
      <div class="row px-4 my-5">
        <div class="col-12 col-sm-4 py-3 px-5 px-sm-2">
          <img
            class="phone1 w-100"
            src="../assets/phone1.png"
            alt="Room View"
          />
        </div>
        <div class="col-12 col-sm-4 py-3 px-5 px-sm-2">
          <img
            class="phone2 w-100"
            src="../assets/phone2.png"
            alt="Send G-Coins"
          />
        </div>
        <div class="col-12 col-sm-4 py-3 px-5 px-sm-2">
          <img
            class="phone3 w-100"
            src="../assets/phone3.png"
            alt="Message View"
          />
        </div>
      </div>
    </section>
    <!-- features -->
    <section class="container">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row">
            <div
              class="col-12 p-3 text-center text-md-start home-virtical-between"
            >
              <video
                src="../assets/intro2.mp4"
                poster="../assets/intro-video-cover.png"
                controls
                class="home-video"
              ></video>
              <p class="mt-4">
                <span class="fw-bold">{{
                  $t("home-old.features.title1")
                }}</span>
                <br />
                <span class="fw-light"
                  ><small>{{ $t("home-old.features.text1") }}</small></span
                >
              </p>
              <p class="mt-4">
                <span class="fw-bold">{{
                  $t("home-old.features.title2")
                }}</span>
                <br />
                <span class="fw-light"
                  ><small>{{ $t("home-old.features.text2") }}</small></span
                >
              </p>
              <p class="mt-4">
                <span class="fw-bold">{{
                  $t("home-old.features.title3")
                }}</span>
                <br />
                <span
                  ><small>{{ $t("home-old.features.text3") }}</small></span
                >
              </p>
              <p class="mt-4">
                <span class="fw-bold">{{
                  $t("home-old.features.title4")
                }}</span>
                <br />
                <span class="fw-light"
                  ><small>{{ $t("home-old.features.text4") }}</small></span
                >
              </p>
              <p class="mt-4">
                <span class="fw-bold">{{
                  $t("home-old.features.title5")
                }}</span>
                <br />
                <span class="fw-light"
                  ><small>{{ $t("home-old.features.text5") }}</small></span
                >
              </p>
            </div>
          </div>
        </div>
        <div
          class="col-12 p-3 col-md-6 home-video-column home-virtical-between"
        >
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/mining.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title1")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text1") }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/listen.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title2")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text2") }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/reward.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title3")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text3") }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/promote.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title4")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text4") }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/grow.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title5")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text5") }}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <img class="text-icon" src="../assets/mic.png" alt="" />
            </div>
            <div class="col ps-4">
              <p>
                <span class="text-golden fw-bold">{{
                  $t("home.features.icon-title6")
                }}</span>
                <br />
                <span>{{ $t("home.features.icon-text6") }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- middle banner -->
    <section class="container nft-sect p-5 mt-3">
      <div class="row align-items-center text-white text-center">
        <div class="col-12 col-md-4 py-5">
          <span>{{ $t("home-old.nft-text1") }}</span>
        </div>
        <div class="col-12 col-md-4">
          <img src="../assets/icon-nft.png" alt="" />
        </div>
        <div class="col-12 col-md-4 py-5">
          <span>{{ $t("home-old.nft-text2") }}</span>
        </div>
      </div>
    </section>
    <!-- call to action -->
    <section class="container bg-white p-5">
      <div class="row w-75 mx-auto align-items-center">
        <div class="col-12 d-lg-none">
          <div
            class="d-flex w-75 mx-auto justify-content-center align-items-center"
          >
            <img src="../assets/gs.png" alt="" class="w-25 m-3" />
            <img src="../assets/gcoin.png" alt="" class="w-25 m-3" />
          </div>
        </div>
        <div
          class="col-12 col-lg-6 d-flex justify-content-end align-items-center my-3"
        >
          <img
            src="../assets/gcoin.png"
            alt=""
            class="d-none d-lg-inline mx-3"
          />
          <span class="text-center text-bigger fw-bold">{{
            $t("home-old.downloadtitle")
          }}</span>
        </div>
        <div class="col-12 col-lg-6 d-flex">
          <div class="row align-items-center">
            <div
              class="col-12 col-lg-6 d-flex text-center align-items-center justify-content-center"
            >
              <a href="#" class="text-center">
                <img
                  src="../assets/gplay.png"
                  alt="Google Play Link"
                  class="w-100"
                />
              </a>
            </div>
            <div
              class="col-12 col-lg-6 d-flex text-center align-items-center justify-content-center"
            >
              <a href="#" class="text-center">
                <img
                  src="../assets/astore.png"
                  alt="Apple Store Link"
                  class="w-100"
                />
              </a>
            </div>
          </div>
          <img src="../assets/gs.png" alt="" class="d-none d-lg-inline mx-3" />
        </div>
      </div>
    </section>
    <!-- user collage -->
    <section class="container bg-white p-3 pb-5">
      <div class="row">
        <img src="../assets/people.png" alt="" />
      </div>
      <div class="row px-4">
        <h1 class="text-golden fw-bold pt-4 fst-italic sansita">
          {{ $t("home-old.empowertitle") }}
        </h1>
      </div>
      <div class="row align-items-center px-4">
        <div class="col-12 col-sm-7">
          <h3 class="text-light-blue fw-bold">
            {{ $t("home-old.excited") }}
          </h3>
        </div>
        <div class="col-6 col-sm-3">
          <h4 class="fw-bold">{{ $t("home-old.downloadNow") }}</h4>
        </div>
        <div class="col-6 col-sm-2 text-center">
          <img src="../assets/app-qr.png" class="qr-code" alt="QR Code" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  methods: {
    clickToCopy() {
      navigator.clipboard.writeText("GoldMining_G");
      alert("Copied the text: " + "GoldMining_G");
    },
  },
};
</script>

<style scoped>
.golden-link {
  font-family: "Poppins", sans-serif;
  height: 100%;
  margin: 0;
  background: linear-gradient(270deg, #c4fff7 -26.45%, #cde1ff 109.06%);
  color: #3b3e51;
}
.text-golden {
  color: #ef8200;
}
.bg-golden {
  background-color: #ef8200 !important;
  border-color: #ef8200 !important;
}
.text-light-blue {
  color: #3daec9;
}
.btn-block {
  width: 100%;
}
.header-menu {
  background: linear-gradient(
    180deg,
    #ffffff 22.4%,
    rgba(255, 255, 255, 0) 100%
  );
  position: absolute;
  top: 0;
  width: 100%;
  height: 100px;
  color: #fff;
  padding: 1rem 0 0 1rem;
}
.header-menu a {
  color: #3b3e51;
  font-size: 0.9rem;
}
.navbar-brand img {
  width: 198px;
}
.show .nav-item {
  border-bottom: 1px solid rgba(168, 195, 236, 0.36);
  padding: 1.5rem 0;
  font-size: 1rem;
}
.home-banner-text {
  font-family: "Poppins", sans-serif;
  color: #ef8200;
  font-weight: bold;
  font-size: 16vw;
  line-height: 17vw;
  letter-spacing: -0.05em;
}
.qr-code {
  max-width: 100%;
}
@media (min-width: 768px) {
  .header-menu {
    padding: 0;
    background: linear-gradient(
      180deg,
      #ffffff 22.4%,
      rgba(255, 255, 255, 0) 100%
    );
    height: 160px;
  }
  .home-banner-text {
    font-size: 9vw;
    line-height: 8.5vw;
  }
  .btn-block {
    width: auto;
  }
}
@media (min-width: 992px) {
  .home-virtical-between {
    height: 52rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .home-virtical-between p {
    margin-bottom: 0;
  }
}
@media (min-width: 1200px) {
  .golden-link {
    .home-banner {
      margin-top: 0;
    }
    .home-banner-text {
      font-size: 7.5rem;
      line-height: 7.5rem;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }
  }
}
@media (min-width: 1400px) {
  .golden-link .container,
  .golden-link .container-lg,
  .golden-link .container-md,
  .golden-link .container-sm,
  .golden-link .container-xl {
    max-width: 1144px;
  }
}
.first-container,
.home-banner {
  margin: 80px auto 0;
}
.home-banner img {
  width: 100%;
}
.home-video {
  border: solid 1rem #70bce5;
  border-radius: 0.5rem;
  width: 100%;
  margin: 0 auto;
  display: block;
}
.text-icon {
  height: 1.8rem;
  margin-right: 0.8rem;
}
.nft-sect {
  background-color: #3daec9;
}
.text-bigger {
  font-size: 1.3rem;
}
footer {
  background: #3b3e51;
  padding: 3rem 0;
}
footer a {
  color: white;
  font-size: 15px;
  text-decoration: none;
}
</style>
